import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { lightThemeColors } from "../../assets/styles/colors";
import moment from "moment";
import SecondaryButton from "../Generic/SecondaryButton";
import PrimaryButton from "../Generic/PrimaryButton";
import { usePaymentsContext } from "../../context/usePaymentsContext";
import { useOutlet, useOutletContext } from "react-router-dom";
import { useInstanceContext } from "../../context/useInstanceContext";
import { showGenericError } from "../../helper/Notifications";
import AdminRoleRequired from "../../helper/AdminRoleRequired";

const DetailsElement = ({ elementDetails, elementTitle }) => {
  return (
    <ElementWrapper>
      <p>{elementTitle}</p>
      <h1>{elementDetails}</h1>
    </ElementWrapper>
  );
};
const EnterpriseDetails = ({ setIsModalOpen }) => {
  const { subscription } = usePaymentsContext();

  return (
    <Container>
      <TitleWrapper>
        <h1>Subscription Details</h1>
      </TitleWrapper>

      <Line>
        <DetailsElement
          elementDetails={
            subscription
              ? `${moment(subscription?.start_at).format("MMM DD, YYYY")}`
              : `-`
          }
          elementTitle={"Start Date"}
        />
        <DetailsElement
          elementDetails={
            subscription
              ? `${moment(subscription?.end_at).format("MMM DD, YYYY")}`
              : `-`
          }
          elementTitle={"End Date"}
        />
      </Line>
    </Container>
  );
};

export default EnterpriseDetails;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  width: 100%;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  h1 {
    color: ${lightThemeColors.darkColorFaded};
    font-size: 20px;
    font-weight: 700;
    line-height: 24px;
    text-align: left;
  }
`;
const Line = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
`;

const ElementWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0px;
  padding: 0 15px;
  h1 {
    color: ${lightThemeColors.darkColorFaded};
    font-size: 16px;
    font-weight: 600;
    line-height: 27px;
    text-align: left;
  }
  p {
    color: ${lightThemeColors.darkColorFaded30};
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    text-align: left;
  }
`;
